import { Component, Input, OnInit, Injectable, Inject } from '@angular/core';
import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import { FormBuilder, FormGroup, Validators  } from '@angular/forms';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../../environments/environment';


@Component({
  selector: 'app-aboutus-overview',
  templateUrl: './aboutus-overview.component.html',
  styleUrls: ['./aboutus-overview.component.scss']
})
export class AboutusOverviewComponent implements OnInit {

  constructor(private http: HttpClient, private formBuilder: FormBuilder, private modalService: NgbModal, @Inject('API_ENDPOINT') private api_endpoint: string) { }

  public overviewForm: FormGroup;
  // public homebanners=[];
  submitted = false;
  message = null;
  class = null;
  action = null;

  ngOnInit() {
    this.overviewForm = this.formBuilder.group({
      overview: ['', Validators.required],
      vision: ['', [Validators.required]],
      mission: ['', Validators.required],
      usps: ['', [Validators.required]],
      campus: ['', Validators.required],
      green: ['', [Validators.required]],
      innovation: ['', Validators.required],
      ragging: ['', [Validators.required]],
      seohidden: [''],
      _id: [''],
    });
// console.log(this.api_endpoint);
    this.http.get<any>(this.api_endpoint+'/aboutoverviewfindone/').subscribe(
        data => {
          if(data.data != null){
            this.action = 'Update';
            this.overviewForm.patchValue({
              overview: data.data.overview,
              vision: data.data.vision,
              mission: data.data.mission,
              usps: data.data.usps,
              campus: data.data.campus,
              green: data.data.green,
              innovation: data.data.innovation,
              ragging: data.data.ragging,
              seohidden: data.data.seohidden,
              _id: data.data._id,
            })
          }else{
            this.action = 'Submit';
            this.overviewForm.patchValue({
              overview: '',
              vision: '',
              mission: '',
              usps: '',
              campus: '',
              green: '',
              innovation: '',
              ragging: '',
              seohidden: '',
              _id: '',
            })
          }
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
    });
  }

  get f() { return this.overviewForm.controls; }

  onFormSubmit(action){
    // alert(action);
    // console.log(this.overviewForm.value);

    this.submitted = true;
    if(action == 'Update'){
      var data = {
        "overview" : this.overviewForm.value.overview,
        "vision" : this.overviewForm.value.vision,
        "mission" : this.overviewForm.value.mission,
        "usps" : this.overviewForm.value.usps,
        "campus" : this.overviewForm.value.campus,
        "green" : this.overviewForm.value.green,
        "innovation" : this.overviewForm.value.innovation,
        "ragging" : this.overviewForm.value.ragging,
        "seohidden" : this.overviewForm.value.seohidden,
        "admin" : sessionStorage.getItem('adminName'),
        "_id" : this.overviewForm.value._id,
      };
      this.http.put<any>(this.api_endpoint+'/aboutoverview', data).subscribe(
        res => {
          // console.log(res);
          if(res.Error){
            this.message = res.Error;
            this.class = 'btn btn-primary';
            return
          }else{
            this.message = 'Successfully Updated';
            this.class = 'btn btn-success';
          } 
          window.location.reload();
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    }else if(action == 'Submit'){
      // alert(this.overviewForm.value.overview);
      var data1 = {
        "overview" : this.overviewForm.value.overview,
        "vision" : this.overviewForm.value.vision,
        "mission" : this.overviewForm.value.mission,
        "usps" : this.overviewForm.value.usps,
        "campus" : this.overviewForm.value.campus,
        "green" : this.overviewForm.value.green,
        "innovation" : this.overviewForm.value.innovation,
        "ragging" : this.overviewForm.value.ragging,
        "seohidden" : this.overviewForm.value.seohidden,
        "admin" : sessionStorage.getItem('adminName'),
      };
      this.http.post<any>(this.api_endpoint+'/aboutoverview', data1).subscribe(
        res => {
          // console.log(res);
          if(res.Error){
            this.message = res.Error;
            this.class = 'btn btn-primary';
            return
          }else{
            this.message = 'Successfully Added';
            this.class = 'btn btn-success';
          } 
          window.location.reload();
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    }
  }

}
